export interface VairProBadgesPayload {
  userIds: string[];
  sport?: string;
}

/** bounceUserId → whether that active coach is a VAIR Pro in the requested sport */
export type VairProBadgesResponse = Record<string, boolean>;

export const VAIR_PRO_BADGES_MAX_USER_IDS = 500;

export const VAIR_PRO_BADGES_API = 'v1/vair/pro-badges';
